module.exports = __webpack_public_path__ + "img/bianzu_en.f675576a.png";